import { middleware } from './middleware';
import { exportModule } from './module';

// The module exists only to register the `stories` locale-loader middleware —
// composeApp takes no top-level middleware, so it must ride on a module.
export const StoriesModule = exportModule({
  middleware
});
